











import Component, { mixins } from "vue-class-component";
import UploadingProgressMixin from "../mixins/UploadingProgressMixin";

@Component({ name: "LoadingThumbnail" })
export default class LoadingThumbnail extends mixins(UploadingProgressMixin) {}
